export enum SpotMarketExceptionReason {
  ALREADY_ACCEPTED_SAME_CARRIER = 'ALREADY_ACCEPTED_SAME_CARRIER',
  ALREADY_ACCEPTED_DIFFERENT_CARRIER = 'ALREADY_ACCEPTED_DIFFERENT_CARRIER',
  MISSING_EMAIL = 'MISSING_EMAIL',
  CANCELLED = 'CANCELLED',
}
